import React from 'react';
import {Col, Form, Row} from "antd";
import SelectDepartmentJobPositionEmployee from "./objectAssign";
import {attendanceGps} from "../constant/key";
import {t} from "i18next";
const SelectAssignObject = ({form,placeholder}) => {
    return (
        <Row gutter={16}>
            <Col
                xxl={{span: 16}}
                xl={{span: 16}}
                lg={{span: 16}}>
                <Form.Item
                    label={<b>{t("tnp.setting.objectAssignText")}</b>}
                    name={attendanceGps.assignmentObjects}
                >

                    <SelectDepartmentJobPositionEmployee mode={"multiple"}
                                                         placeholder={placeholder}
                                                         name={attendanceGps.assignmentObjects}
                                                         form={form}/>
                </Form.Item>
            </Col>
        </Row>
    );
};


export default SelectAssignObject;
